import DeleteDeviceContainer from './containers/DeleteDeviceContainer'

export default DeleteDeviceContainer
